// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM9.93945 5.14453C7.12256 6.12085 5.09887 8.79626 5.09863 11.9453C5.09863 15.9204 8.32184 19.1434 12.2969 19.1436C15.5831 19.1435 18.3519 16.94 19.2139 13.9307C16.8238 16.3 12.8796 16.2075 10.3896 13.7178C7.98575 11.3136 7.81546 7.55228 9.93945 5.14453Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
